import { GasDividerModule } from './../gas-divider/gas-divider.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasCardComponent } from './gas-card.component';
import { GasSpinnerModule } from '../../common/gas-spinner/gas-spinner.module';
import { GasCardFooterComponent } from './footer/gas-card-footer.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';

const COMPONENTS = [
  GasCardComponent,
  GasCardFooterComponent,
];

@NgModule({
  imports: [
    CommonModule,
    GasSpinnerModule,
    GasIconsModule,
    GasDividerModule,
  ],
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
})
export class GasCardModule { }
